__webpack_require__.p = "/tokens-buttons-figma-alignement/account-setup/";